import React from 'react';
import { PillUnit } from '@mark43/cad-api';

export const EventPanelUnitsContext = React.createContext<PillUnit[]>([]);
